/** Pupil size, as fractions of the dog image (measured from the original eyes). */
const PUPIL = { width: 0.031, height: 0.037 };

/** Pupil centers, as fractions of the dog image (measured from the original eyes). */
const CENTERS = [
  { x: 0.211, y: 0.286 },
  { x: 0.375, y: 0.244 },
];

/**
 * Pupils drawn over `assets/nowadays-dog-eyeless.png`, the loading dog with its
 * eyes painted out, and how they follow the cursor.
 */
export const FOOTER_DOG_EYES = {
  pupil: PUPIL,
  centers: CENTERS,
  /** Same brown as the line art. */
  color: "#603913",
  look: {
    /** Midway between the eyes, so both pupils turn toward the same point. */
    origin: { x: (CENTERS[0].x + CENTERS[1].x) / 2, y: (CENTERS[0].y + CENTERS[1].y) / 2 },
    /** About half a pupil's width. */
    reach: 0.45 * PUPIL.width,
    fullReachDistance: 200,
    /** Critically damped so the pupils glide over without wobbling. */
    spring: { stiffness: 300, damping: 35 },
  },
} as const;
